import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

@Component({
  selector: 'app-current-account-balance',
  templateUrl: './current-account-balance.component.html',
  styleUrls: ['./current-account-balance.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CurrentAccountBalanceComponent implements OnChanges {
  @Input() accountBalance?: number;
  @Input() loading = true;
  @Input() error: any;
  @Input() errorMessage?: string;
  @Output()
  public refresh = new EventEmitter<MouseEvent>();
  hasProblem = false;

  ngOnChanges(): void {
    this.hasProblem = !!this.error || this.accountBalance === undefined;
  }

  refreshAccountBalance(event: MouseEvent) {
    this.refresh.emit(event);
  }
}
